import React from 'react';
import axios from "axios";
import { toast } from 'react-toastify';

const PayButton = ({ cartItems, list_items }) => {

    const handleCheckout = () => {
        const token = localStorage.getItem('Bearer');
        console.log("Token: ", token);

        console.log("Cart items: ", cartItems);

        // Check if any item is missing personalization
        const missingPersonalization = cartItems.some(item => !item.personalisation);

        if (missingPersonalization) {
            toast.warn("Some items are missing personalization. Don't forget to add it!", {
                position: "top-center",
                autoClose: 5000,
            });
        }

        axios.post(`${process.env.REACT_APP_URL}/api/create-checkout-session`, {
            cartItems,
            list_items,
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        }).then((res) => {
            if (res.data.url) {
                window.location.href = res.data.url;
            }
        }).catch((error) => console.log(error.message));
    };

    return (
        <>
            <button onClick={handleCheckout}>Checkout</button>
        </>
    );
}

export default PayButton;
